import { useState } from 'react';
import { Box, Typography, Divider, TextField, Button } from '@material-ui/core';
import {
  Close,
  Label,
  Search,
  Add,
  KeyboardBackspace,
} from '@material-ui/icons';

import { useConnect } from '../../../context/connect';
import { useCheckUpdates } from '../../../hooks/useCheckUpdates';
import { List } from './List';

import { useStyles } from './style';
import { Form } from './Form';
import { ICannedReply } from '../../../interfaces';

export const CannedResponsesPanel = () => {
  const classes = useStyles();
  const { setAgentNav, contact, setShortcut } = useConnect();

  const [mode, setMode] = useState<null | 'create' | 'update'>(null);
  const [dataForUpdate, setDataForUpdate] = useState<undefined | ICannedReply>(
    undefined
  );

  const modeTitle = mode
    ? mode === 'create'
      ? 'Add Response'
      : 'Update Response'
    : 'Canned Responses';

  useCheckUpdates();

  const onClose = () => {
    setAgentNav(contact ? 'customer_info' : null);
  };

  return (
    <Box className={classes.wrapper} position={'relative'}>
      <Box className={classes.header}>
        <Box
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
          width={1}
        >
          <Box display={'flex'} alignItems={'center'}>
            {!!mode && (
              <Box onClick={() => setMode(null)} mr={1}>
                <KeyboardBackspace
                  style={{ cursor: 'pointer', display: 'block' }}
                />
              </Box>
            )}
            <Typography variant="button" style={{ lineHeight: 1 }}>
              {modeTitle}
            </Typography>
          </Box>
          <Box className={classes.icon} onClick={onClose}>
            <Close />
          </Box>
        </Box>
        {!mode && (
          <>
            <Box width={1} my={1}>
              <Divider variant="fullWidth" />
            </Box>
            <Box display={'flex'} my={1} alignItems="center">
              <Box flex={1}>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="#shortcuts"
                  size="small"
                  onChange={(e) => setShortcut(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <Label fontSize="small" style={{ marginRight: '5px' }} />
                    ),
                    endAdornment: (
                      <Search fontSize="small" style={{ opacity: 0.4 }} />
                    ),
                  }}
                />
              </Box>
              <Box ml={1}>
                <Button
                  variant="contained"
                  color={'primary'}
                  size="small"
                  onClick={() => setMode('create')}
                  style={{
                    background: 'rgb(37, 124, 175)',
                    borderRadius: '2px',
                    boxShadow: 'none',
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <Add fontSize="small" />
                    <Box
                      ml={0.5}
                      mt={0.3}
                      style={{
                        textTransform: 'none',
                      }}
                    >
                      Add New
                    </Box>
                  </Box>
                </Button>
              </Box>
            </Box>
          </>
        )}
      </Box>
      <Box className={classes.body}>
        {!mode ? (
          <List setDataForUpdate={setDataForUpdate} setMode={setMode} />
        ) : (
          <Form
            mode={mode}
            setDataForUpdate={setDataForUpdate}
            initialData={dataForUpdate}
            setMode={setMode}
          />
        )}
      </Box>
      <Box className={classes.footer}></Box>
    </Box>
  );
};
